export class TravelAgendaModel {
  constructor(
    public id = null,
    public patientConsultationId = null,
    public departDate = new Date(),
    public returnDate = new Date(),
    public tripReason = null,
    public accomodationType = null,
    public tripCountries = []
  ) {
    this.id = id;
    this.tripCountries = tripCountries;
    this.accomodationType = accomodationType;
    this.patientConsultationId = patientConsultationId;
    this.returnDate = returnDate;
    this.tripReason = tripReason;
    this.departDate = departDate;
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/consultation-history/travel-agenda.model.ts